<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {pad0} from "../../lib/lib";

    export let id = '';
    export let value = null;
    export let disabled = false;
    export let cssClass = '';

    let inputTime = null;
    let oldValue = null;
    let seconds = null;

    const dispatch = createEventDispatcher();

    const onFocus = () => {
        if (inputTime) {
            inputTime = inputTime.replaceAll(":", "");
        }
    }

    const onFocusOut = () => {
        setTheTime();
    }

    const setTheTime = () => {
        let hour;
        let minutes;
        if (inputTime) {
            if (inputTime.length < 3) {
                hour = inputTime;
                minutes = 0;
            } else {
                minutes = inputTime.slice(-2);
                hour = inputTime.slice(0, inputTime.length - 2);
                if (hour && hour > 23) hour = 0;
                if (minutes && minutes > 59) minutes = 0;
            }

            inputTime = `${pad0(hour)}:${pad0(minutes)}`;
            value = inputTime + (seconds ? `:${seconds}` : '');
        } else {
            inputTime = null;
            value = null;
        }

        if (oldValue != value) {
            dispatch('change', value);
        }
    }

    const getSecondsFromTime = (timeStr) => {
        if (!timeStr) {
            return '';
        }
        let parts = timeStr.split(":");
        if (parts.length < 3) {
            return '';
        }
        return parts[2];
    }

    $: {
        if (value && seconds === null) {
            // initialize the seconds
            seconds = getSecondsFromTime(value);
        }
        if (value !== oldValue) {
            if (value) {
                let [h, m, s] = value.split(":");
                inputTime = `${h}:${m}`;
            }
            oldValue = value;
        }
    }
</script>

<input type="text" id={id} class="form-control {cssClass}" bind:value={inputTime}
       autocomplete="off"
       placeholder="hh:mm"
       maxlength="4"
       on:focus={onFocus}
       on:focusout={onFocusOut} {disabled}>
